import { render } from "./TrainingSummaryView.vue?vue&type=template&id=9ae4be76"
import script from "./TrainingSummaryView.vue?vue&type=script&lang=js"
export * from "./TrainingSummaryView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__